import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CapacityCategory } from 'Models/Shared/Capacity/CapacityCategory';
import { store } from 'Models/Store';
import OverbookingModal from './OverbookingModal';
import { OverbookingWarningDto } from './OverbookingWarningDto';
import OverbookingWithInsightModal from './OverbookingWithInsightModal';

const formattedMessages = {
	confirmed: 'reservation__overbooking-modal__action-confirmed',
	denied: 'reservation__overbooking-modal__action-denied',
} as const;

interface Props {
	onClickCross: (capacityCategory: CapacityCategory) => void;
	onClickSelect: (capacityCategory: CapacityCategory) => void;
	departingOverbookingWarnings?: OverbookingWarningDto[];
	returningOverbookingWarnings?: OverbookingWarningDto[];
}

export function OverbookingModalManager({
	onClickCross,
	onClickSelect,
	departingOverbookingWarnings,
	returningOverbookingWarnings,
}: Props) {
	const canOverbook = store.can('OverbookInBookingWizard');
	const actionText = React.useMemo(() => {
		if (canOverbook) {
			return <FormattedMessage id={formattedMessages.confirmed} defaultMessage="Continue to cart" />;
		}
		return <FormattedMessage id={formattedMessages.denied} defaultMessage="Ok" />;
	}, [canOverbook]);

	const getCapacityCategory = () => {
		if (
			departingOverbookingWarnings?.find(x => x.capacityType === 'Vehicle') ||
			departingOverbookingWarnings?.find(x => x.capacityType === 'Trailer') ||
			departingOverbookingWarnings?.find(x => x.capacityType === 'Passenger') ||
			returningOverbookingWarnings?.find(x => x.capacityType === 'Vehicle') ||
			returningOverbookingWarnings?.find(x => x.capacityType === 'Trailer') ||
			returningOverbookingWarnings?.find(x => x.capacityType === 'Passenger')
		) {
			return 'Vehicle';
		}
		if (
			departingOverbookingWarnings?.find(x => x.capacityType === 'AddOn') ||
			returningOverbookingWarnings?.find(x => x.capacityType === 'AddOn')
		) {
			return 'AddOn';
		}
		return 'Vehicle';
	};

	if (!store.isStaff) {
		return (
			<OverbookingModal
				onClickCross={(capacityCategory: CapacityCategory) => onClickCross(capacityCategory)}
				onClickSelect={(capacityCategory: CapacityCategory) => onClickSelect(capacityCategory)}
				departingOverbookingWarnings={departingOverbookingWarnings}
				returningOverbookingWarnings={returningOverbookingWarnings}
			/>
		);
	}

	if (departingOverbookingWarnings || returningOverbookingWarnings) {
		return (
			<OverbookingWithInsightModal
				showModal
				actionText={actionText}
				onClickCross={() => onClickCross(getCapacityCategory())}
				onClickSelect={() => onClickSelect(getCapacityCategory())}
				departingOverbookingWarnings={departingOverbookingWarnings}
				returningOverbookingWarnings={returningOverbookingWarnings}
			/>
		);
	}

	return <></>;
}
